import { HeroBackgroundImage } from "../../../../modules/content/components/HeroBackgroundImage/HeroBackgroundImage";
import { HeroSplitImage } from "../../../../modules/content/components/HeroSplitImage/HeroSplitImage";
import { SproutSection } from "../../../../modules/content/components/SproutSection/SproutSection";
import type { IHeroBlockProps } from "./HeroBlock.props";

export const HeroBlock = (props: IHeroBlockProps) => {
  if (!props.image) return null;
  return (
    <SproutSection
      className={props.parentClass}
      containerWidth="wide"
      id={props.anchorId}
      spacing={props.spacing}
    >
      {props.variant === "split-image" ? (
        <HeroSplitImage {...props} />
      ) : (
        <HeroBackgroundImage {...props} />
      )}
    </SproutSection>
  );
};

HeroBlock.displayName = "Block::HeroBlock";
